import { LegacyRef } from 'react';

import { Button } from '@atom/button/button';
import { ButtonTypeEnum } from '@atom/button/button.enum';
import { Text } from '@atom/typography/typography';
import { ColorEnum } from '@enum/style/color.enum';
import { OtpForm } from '@form/otp/otp.form';
import { ErrorFormInterface } from '@interface/form/error-form.interface';

import { useToggleMfa } from './toggle-mfa.hook';
import { MFAWrapper, QRCodeElement } from './toggle-mfa.style';

export const ToggleMfa = () => {
  const { qrcode, form, hasMfaPath, isLoading, isEnabled, isDisableState, error, onMfa } = useToggleMfa();

  return (
    <>
      {(hasMfaPath || isDisableState) && (
        <MFAWrapper>
          {!isDisableState && <QRCodeElement ref={qrcode as LegacyRef<HTMLCanvasElement>} />}
          <OtpForm error={error as ErrorFormInterface} form={form} />
        </MFAWrapper>
      )}
      <Button loading={isLoading} type={ButtonTypeEnum.Primary} ghost onClick={onMfa}>
        <Text color={ColorEnum.Inherit} level='m'>
          {!isEnabled && (hasMfaPath ? 'Validate MFA' : 'Enable MFA')}
          {isEnabled && (hasMfaPath ? 'Validate MFA' : 'Disable MFA')}
        </Text>
      </Button>
    </>
  );
};
